import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"

const Faq = () => {
  return (
    <div className="mx-auto w-[1360px] max-w-full pb-[40px]">
      <div className="max-w-full lg_w-[1360px]">
        <p className="mb-[46px] text-center text-[24px] font-[700] leading-[48px] text-title lg_text-[48px]">
          Frequenty Asked Questions
        </p>
      </div>

      <div className="flex flex-col gap-[10px] px-[10px] lg_px-0">
        <Accordion
          type="multiple"
          className="mt-[20px] w-full border-t border-[#EFEFEF] lg_mt-[40px]"
          defaultValue={[]}
        >
          <AccordionItem value="item-1">
            <AccordionTrigger className="h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]">
              <h2 className="pr-[40px]">
                1. How do I connect the feeder to my phone?{" "}
              </h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className="border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title">
                Our smart bird feeders connect via 2.4GHz Wi-Fi (5GHz not
                supported). Simply download the companion app and follow the
                in-app instructions to pair your device during setup.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value="item-2">
            <AccordionTrigger className="h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]">
              <h2 className="pr-[40px]">
                2. Can the feeder take photos or videos automatically?{" "}
              </h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className="border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title">
                Yes! The built-in motion sensor activates the camera when birds
                approach. Photos and videos are automatically saved to your
                phone or the cloud, depending on your settings.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value="item-3">
            <AccordionTrigger className="h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]">
              <h2 className="pr-[40px]">3. Does it identify bird species?</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className="border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title">
                The feeder uses AI to recognize common bird species such as
                cardinals, blue jays, goldfinches, and more. Accuracy depends on
                lighting, angle, and photo clarity.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value="item-4">
            <AccordionTrigger className="h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]">
              <h2 className="pr-[40px]">
                4. What’s the battery life? Is it rechargeable?
              </h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className="border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title">
                Most feeders last 2–4 weeks on a full charge, depending on
                usage. All models include a rechargeable battery, and some also
                support solar charging for extended use.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value="item-5">
            <AccordionTrigger className="h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]">
              <h2 className="pr-[40px]">
                5. Do I need a subscription for full features?{" "}
              </h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className="border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title">
                Basic features like live view, photo capture, and video
                recording are free. Advanced features—such as cloud storage and
                enhanced bird recognition—may require a paid subscription.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value="item-5">
            <AccordionTrigger className="h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]">
              <h2 className="pr-[40px]">6. Is the feeder weatherproof? </h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className="border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title">
                Yes, our smart feeders are built for year-round outdoor use and
                are typically rated IP65 or higher, offering protection against
                rain and dust.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value="item-5">
            <AccordionTrigger className="h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]">
              <h2 className="pr-[40px]">
                7. How do I mount or install the feeder?{" "}
              </h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className="border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title">
                The feeder can be mounted on a pole, wall, tree, or fence using
                included brackets or hooks. For best results, choose a spot with
                strong Wi-Fi and good sunlight (if using solar power).
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
  )
}

export default Faq
